<template>
  <v-container>
    <keep-alive>
      <v-layout column>
        <v-flex>
          <h1>Bulk Select By ID</h1>
        </v-flex>
        <v-flex pb-2>
          <v-card>
            <v-card-text>
              <v-form @submit.prevent="searchForPeople">
                <v-textarea
                  :error="status == 'error'"
                  :error-messages="message"
                  prepend-icon="search"
                  placeholder="List of Pharmacist ID's or HPI's (one per line)"
                  v-model.trim="searchString"
                  :autofocus="true"
                  rows="10"
                  @change="results = []"
                  :messages="`${idFilter.length} / 500`"
                ></v-textarea>

                <v-btn @click="searchForPeople" :loading="status === 'loading'">
                  See sample...
                </v-btn>
                <v-btn
                  primary
                  @click="pracStatusDialogBox.display = true"
                  ml-2
                  primary
                >
                  Bulk Update Practicing Status...
                </v-btn>
              </v-form>
              <v-divider ma-2 />
            </v-card-text>
          </v-card>

          <v-data-table
            v-if="results.length"
            dense
            :items="results"
            :loading="status === 'loading'"
            :headers="tableHeaders"
          >
            <template v-slot:item="props">
              <!-- <tr @click="$router.push('/people/'+props.item.id)"> -->
              <tr @dblclick="$router.push('/people/' + props.item.id)">
                <!-- <td>#{{ props.item.id }}</td> -->
                <td>{{ props.item.displayName }}</td>
                <!-- <td>{{ props.item.title }}</td>
                    <td>{{ props.item.nickname }}</td>
                    <td>{{ props.item.firstname }}</td>
                    <td>{{ props.item.middlenames }}</td>
                    <td>{{ props.item.surname }}</td> -->

                <td
                  v-if="
                    props.item.practitioner &&
                    props.item.practitioner.practicingstatus
                  "
                >
                  {{ props.item.practitioner.practicingstatus.name }}
                  <span
                    v-if="
                      props.item.practitioner &&
                      props.item.practitioner.statuses &&
                      props.item.practitioner.statuses[0] &&
                      props.item.practitioner.statuses[0].option
                    "
                  >
                    ({{ props.item.practitioner.statuses[0].option.name }})
                  </span>
                </td>
                <td v-else></td>

                <td v-if="props.item.apc && props.item.apc.expirydate">
                  <span
                    v-if="
                      props.item.apc &&
                      props.item.apc.certificatetype &&
                      props.item.apc.certificatetype.name
                    "
                  >
                    ({{ props.item.apc.certificatetype.name }})
                  </span>
                  {{ props.item.apc.expirydate | formatDate }}
                </td>
                <td v-else></td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-dialog
          card
          v-if="pracStatusDialogBox.display"
          v-model="pracStatusDialogBox.display"
        >
          <v-form>
            <v-card>
              <v-card-title>Bulk Update Practicing Status:</v-card-title>
              <v-card-text>
                <v-checkbox
                  v-model="practitionerChanges.pendingpracstatusprocessed"
                  label="Update Status by schedule:"
                  off-icon="$checkboxOn"
                  on-icon="$checkboxOff"
                ></v-checkbox>

                <div
                  name="Pending Status"
                  v-if="!practitionerChanges.pendingpracstatusprocessed"
                >
                  <date-picker
                    label="Update status on (end of day)"
                    v-model="practitionerChanges.pendingpracstatusdate"
                    :min="$moment().startOf('day').format('YYYY-MM-DD')"
                  >
                  </date-picker>
                  <lookup-select
                    label="to new status"
                    v-model="practitionerChanges.pendingpracstatus"
                    lookup-name="PracticingStatusOption"
                  >
                  </lookup-select>
                  <v-textarea
                    v-model="practitionerChanges.pendingpracstatusreason"
                    label="Reason for pending change"
                    rows="1"
                    auto-grow
                  ></v-textarea>
                </div>
                <v-layout>
                  <v-flex>
                    <v-btn
                      color="primary"
                      @click="bulkUpdatePractitioner(practitionerChanges)"
                      :disabled="!currentUserCan('editPersonalDetails')"
                    >
                      <!-- :loading="pracStatusDialogBox.UpdateDialogBox" -->
                      Bulk Update {{ requestCount }} record(s)
                    </v-btn>
                  </v-flex>

                  <v-alert
                    active
                    color="error"
                    v-if="pracStatusDialogBox.errorMessage"
                  >
                    {{ pracStatusDialogBox.errorMessage }}
                  </v-alert>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog persistent :value="pracStatusDialogBox.UpdateDialogBox" card>
          <v-card>
            <v-card-title>Updating Now</v-card-title>
            <v-card-text>
              Updating Now. Please keep this window open until finished.
              <v-progress-linear
                :value="pracStatusDialogBox.percent"
                size="large"
              />
              <v-spacer pa-4></v-spacer>
              <v-alert
                :type="
                  pracStatusDialogBox.updatedCount === idFilter.length
                    ? 'success'
                    : ''
                "
              >
                Updated {{ pracStatusDialogBox.updatedCount }} records
              </v-alert>
            </v-card-text>

            <v-card-actions>
              <v-btn
                :disabled="pracStatusDialogBox.updatedCount < idFilter.length"
                @click="pracStatusDialogBox.UpdateDialogBox = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </keep-alive>
  </v-container>
</template>

<script>
export default {
  name: "bulkSelect",
  data() {
    return {
      newPersonDialog: false,
      status: "",
      results: [],
      searchString: "",
      message: [],

      pracStatusDialogBox: {
        display: false,
        successMessage: "",
        errorMessage: "",
        UpdateDialogBox: false,
        percent: 0,
        updatedCount: 0,
        success: false,
      },

      practitionerChanges: {
        pendingpracstatusprocessed: false,
        pendingpracstatusdate: this.$moment()
          .startOf("day")
          .format("YYYY-MM-DD"),
        pendingpracstatus: null,
        pendingpracstatusreason: "",
      },
      tableHeaders: [
        { text: "Person", value: "id" },
        // { text: "title", value: "title" },
        // { text: "Preferred Name", value: "nickname" },
        // { text: "First Name", value: "firstname" },
        // { text: "Middle Names", value: "middlenames" },
        // { text: "Surname", value: "surname" },
        {
          text: "Practising Status",
          value: "practitioner.practicingstatusid",
        },
        {
          text: "Certificate Expires",
          value: "apc.expirydate",
        },
      ],
    };
  },

  computed: {
    idFilter() {
      return this.searchString.split("\n").filter((t) => t);
    },
    requestCount() {
      return this.idFilter.length;
    },
    whereFilter() {
      var whereFilter = {
        or: [{ id: { inq: this.idFilter } }],
      };
      return whereFilter || {};
    },
  },
  methods: {
    searchForPeople: async function (init) {
      if (!this.searchString || this.status === "loading") {
        return;
      }
      this.status = "loading";
      this.message = [];
      console.debug("searching for people");

      try {
        const result = await this.$http.get("/people/", {
          params: {
            filter: {
              where: this.whereFilter,

              include: {
                apc: true,
                practitioner: {
                  statuses: true,
                  scopes: true,
                  scopesonpractice: true,
                },
              },
              limit: 100,
            },
          },
        });
        if (result) {
          console.log("got results: ", result);

          this.status = "success";
          this.results = [...result.data];
        } else {
          throw new Error("No results from server");
        }
      } catch (e) {
        this.status = "error";
        this.message.push(e.message);
        console.error(e);
      }
    },
    // customFilter(person) {
    //   if (!this.searchFilters?.practicingStatusId?.length) {
    //     console.debug("no customfilter found");
    //     return true;
    //   }
    //   try {
    //     console.debug("running CustomFilter", person, this.searchFilters);

    //     if (
    //       this.searchFilters?.practicingStatusId?.includes(
    //         person?.practitioner?.practicingstatusid
    //       )
    //     ) {
    //       console.debug("including in results");
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   } catch (e) {
    //     console.error("error in customfilter execution", e);
    //     return false;
    //   }
    // },
    async bulkUpdatePractitioner(changes) {
      if (!changes) {
        console.warn("no changes found. exiting");
        return false;
      }

      this.pracStatusDialogBox.errorMessage = "";
      this.$set(this.pracStatusDialogBox, "UpdateDialogBox", true);
      this.$set(this.pracStatusDialogBox, "percent", 0);
      const errors = [];
      try {
        const totalCount = this.idFilter.length;
        const pendingIds = this.idFilter;
        var processed = 0;

        console.debug(
          "bulk updating practitioners",
          changes,
          totalCount,
          pendingIds,
          processed
        );

        // while (processed <= totalCount) {
        //   const batch = pendingIds.slice(0, 5);
        //   processed = processed + batch.length;
        //   this.pracStatusDialogBox.percent = (processed / totalCount) * 100;
        //   const patches = Promise.all(
        //     batch.map((id) => {
        //       return this.$http.patch(`/practitioners/${id}`, changes);
        //     })
        //   );
        //   await patches;
        //   console.log("batches:", patches);
        // }
        // while (processed < totalCount) {
        //   const batch = pendingIds.slice(0, 1);
        //   processed = processed + batch.length;

        //   console.log("processing ", processed, " out of ", batch);
        //   this.$set(
        //     this.pracStatusDialogBox,
        //     "percent",
        //     processed / totalCount
        //   );

        for (const idx in pendingIds) {
          try {
            const number = Number(idx) + 1;
            const result = await this.$http.patch(
              `/practitioners/${pendingIds[idx]}`,
              changes
            );
            this.$set(
              this.pracStatusDialogBox,
              "percent",
              (number / totalCount) * 100
            );
            this.$set(this.pracStatusDialogBox, "updatedCount", number);
          } catch (e) {
            errors.push(e);
          }
        }
      } catch (e) {
        errors.push(e);
        this.pracStatusDialogBox.errorMessage = e.message;
        console.error(e);
      } finally {
        // this.$set(this.pracStatusDialogBox, "updating", false);
        this.searchForPeople();
      }
    },
  },
};
</script>
